/* eslint-disable no-empty-pattern */
import roundHistoryItemService from '@/services/roundHistoryItem.js';

export default {
	debug: false,
	namespaced: true,
	state: {
		roundHistoryItems: [],
		roundHistoryItem: {},
		searchParams: {
			customerId: '',
			done: null,
			orderBy: '',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0
	},

	mutations: {
		SET_HISTORYITEMS(state, roundHistoryItems) {
			state.roundHistoryItems = roundHistoryItems;
		},
		SET_HISTORYITEM(state, roundHistoryItem) {
			state.roundHistoryItem = roundHistoryItem;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		}
	},

	actions: {
		async getRoundHistoryItem({ commit }, roundHistoryItemId) {
			return await roundHistoryItemService
				.getRoundHistoryItem(roundHistoryItemId)
				.then(data => {
					commit('SET_HISTORYITEM', data);
				})
				.catch(err => {
					console.log('Error getting roundHistoryItem: ', err);
				});
		},
		async getRoundHistoryItems({ state, commit, dispatch }) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await roundHistoryItemService
				.getRoundHistoryItems(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_HISTORYITEMS', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getRoundHistoryItems');
					}

					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting roundHistoryItems: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},

		async createRoundHistoryItem({ dispatch }, roundHistoryItem) {
			return await roundHistoryItemService
				.createRoundHistoryItem(roundHistoryItem)
				.then(() => {
					dispatch('getRoundHistoryItems');
				})
				.catch(err => {
					console.log('Error creating roundHistoryItem: ', err);
				});
		},
		async updateRoundHistoryItem({}, roundHistoryItem) {
			return await roundHistoryItemService
				.updateRoundHistoryItem(roundHistoryItem)
				.catch(err => {
					console.log('Error updating roundHistoryItem: ', err);
					throw err;
				});
		},
		async deleteRoundHistoryItem({ dispatch }, roundHistoryItem) {
			return await roundHistoryItemService
				.deleteRoundHistoryItem(roundHistoryItem.id)
				.then(() => {
					dispatch('getRoundHistoryItems');
				})
				.catch(err => {
					console.log('Error deleting roundHistoryItem: ', err);
				});
		},

		setRoundHistoryItem({ commit }, roundHistoryItem) {
			commit('SET_HISTORYITEM', roundHistoryItem);
		},
		setRoundHistoryItems({ commit }, roundHistoryItems) {
			commit('SET_HISTORYITEM', roundHistoryItems);
		},
		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},
		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},
		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},
		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		roundHistoryItem: state => {
			return state.roundHistoryItem;
		},
		roundHistoryItems: state => {
			return state.roundHistoryItems;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		}
	}
};
